import { ChangeEvent } from "react";
import styled from "styled-components";

import { Icon } from "components/atoms";

import { SearchComplexFilter, ComplexFilterType } from "interfaces/filters";
import { IconName } from "interfaces/icons";

import { MAIN_THEME } from "styles/colors";

const ClearButton = styled.button`
	position: absolute;
	right: 8px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	cursor: pointer;
	background: transparent;
	outline: none;
	border: none;
	transition: all 0.2s ease;

	&:hover {
		transform: translateY(-50%) scale(1.1);
	}
`;

const IconWrap = styled.div`
	position: absolute;
	left: 8px;
	top: 50%;
	transform: translateY(-50%);
`;

const Container = styled.div<{ width?: string; background?: string; border?: string }>`
	display: flex;
	width: ${({ width }) => width || "350px"};
	position: relative;
	border-radius: 8px;
	border: ${({ border }) => border || `1px solid ${MAIN_THEME.BORDER_COLOR}`};
	background: ${({ background }) => background || MAIN_THEME.DARK_BG_TERTIARY};
	overflow: hidden;
	transition: all 0.3s ease;

	&:focus-within {
		border-color: ${MAIN_THEME.SECONDARY};
	}


	@media (max-width: 768px) {
		width: ${({ width }) => width ? "100%" : "250px"};
	}

	@media (max-width: 480px) {
		width: 100%;
	}
`;

const Input = styled.input`
	border: none;
	height: 44px;
	padding: 0 40px;
	width: 100%;
	outline: none;
	background: transparent;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	font-size: 15px;

	::placeholder {
		color: ${MAIN_THEME.TEXT_TERTIARY};
	}

	@media (max-width: 768px) {
		font-size: 14px;
		height: 40px;
		padding: 0 38px;
	}
`;

interface Props {
	filterData: SearchComplexFilter;
	changeFilter: (filter: SearchComplexFilter) => void;
	placeholder: string;
	width?: string;
	background?: string;
    border?: string;
}

const SearchInput = (props: Props): JSX.Element => {
	const { filterData, changeFilter, placeholder, width, background, border } = props;

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;

		changeFilter({
			type: ComplexFilterType.SEARCH,
			value,
			title: value,
		});
	};

	const handleClear = () => {
		changeFilter({
			type: ComplexFilterType.SEARCH,
			value: null,
		});
	};

		return (
			<Container width={width} background={background} border={border}>
				<IconWrap>
					<Icon name={IconName.SEARCH} color={MAIN_THEME.TEXT_SECONDARY} size={15} />
				</IconWrap>

			<Input
				placeholder={placeholder}
				onChange={handleChange}
				value={filterData.value || ""}
			/>
			{filterData.value ? (
				<ClearButton onClick={handleClear}>
					<Icon name={IconName.CLOSE} color={MAIN_THEME.TEXT_SECONDARY} size={18} />
				</ClearButton>
			) : null}
		</Container>
	);
};

export default SearchInput;
